import type { PullRequestTarget } from '@/data/v2/pr/approve-pull-request';
import type { PrV2MergeResponse } from '@/lib/pr-v2/types';

import { mergePrV2 } from '@/data/v2/pr/fetch-pr-v2';
import { planPullRequestMerge } from '@/data/v2/pr/plan-pull-request-merge';

/** Merges from a notification after checking again that nothing blocks it since it was shown. */
export async function mergeFromNotification(target: PullRequestTarget): Promise<PrV2MergeResponse> {
  const plan = await planPullRequestMerge(target);
  if (!plan.ready) {
    throw new Error(plan.reason);
  }
  return mergePrV2(target.owner, target.repo, String(target.number), plan.merge);
}
